import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import toast from 'react-hot-toast';

import { disconnectSlack } from '../query';
// Custom hook for the mutation
export function useDisconnectSlack(): UseMutationResult<
  void,
  Error,
  { userId: string }
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ userId }: { userId: string }) => {
      await disconnectSlack(userId);
    },
    onSuccess: async () => {
      toast.success('Slack disconnected successfully');
      await queryClient.invalidateQueries({
        queryKey: ['slackConnectionStatus'],
      });
    },
    onError: () => {
      toast.error('Failed to disconnect Slack, Please try again');
    },
  });
}
